import { StdResponse, request } from "@/global/config/request";
import { RsProjectGlobalCable } from "@/global/interface/project-device/project-cable";

export function getProjectCables(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectId}/project-global-cables`, {
        params: {
            ...params,
        }
    })
}

export function createProjectGCables(data: RsProjectGlobalCable[], params?: {}): Promise<StdResponse<any>> {
    return request.post(`/project-global-cables`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteProjectGCable(projectId: number, globalCableId: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/project-global-cables/delete`, {
        params: {
            ...params,
            projectId: projectId,
            globalCableId: globalCableId,
        }
    })
}   